import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Strong } from '../../../components/atoms/Strong/Strong';
import { Heading } from '../Heading/Heading';
import { AttributeGroupRule } from '../../../types/api/AttributeGroups';
import bem from '../../../lib/bemUtils/bem';

export type AttributeGroupRules = {
  rules: AttributeGroupRule[];
  ruleCombination?: 'and' | 'or';
  showHeading?: boolean;
  modifier?: 'combobox';
};

/**
 * Component describing the rules of an Attribute Group.
 */
export function AttributeGroupRules({ rules, ruleCombination, showHeading, modifier }: AttributeGroupRules) {
  const { t } = useTranslation('AttributeGroups');
  if (rules.length === 0) {
    return null;
  }

  return (
    <div className={bem('attribute-group-rules-list', modifier)}>
      {showHeading && (
        <Heading className="attribute-group-rules-list__heading" hierarchy={3}>
          {t('ruleHeadline')}
        </Heading>
      )}
      <dl className="attribute-group-rules-list__definition-list">
        {rules.map((rule, index) => (
          <Fragment key={rule.attributeName + rule.condition + rule.conditionValue}>
            <dt className="invisible">{t('ruleIndex', { position: index + 1 })}</dt>
            <dd className="attribute-group-rules-list__definition-list-description">
              {`${t(`PersonAttributes:${rule.attributeName}`)} `}
              <span aria-hidden="true">{`>`}</span>
              {` (${t(`form.ruleset.condition.${rule.condition}`)}) `}
              <span aria-hidden="true">{`>`}</span>
              {` ${rule.conditionValue}`}
            </dd>
            {ruleCombination && index !== rules.length - 1 && (
              <>
                <dt className="invisible">{t('ruleCombination')}</dt>
                <dd className="attribute-group-rules-list__definition-list-description">
                  <Strong>
                    {modifier === 'combobox' ? '\u00A0' : null}
                    {t(`form.connection.${ruleCombination}`)}
                    {modifier === 'combobox' ? '\u00A0' : null}
                  </Strong>
                </dd>
              </>
            )}
          </Fragment>
        ))}
      </dl>
    </div>
  );
}
